// extracted by mini-css-extract-plugin
module.exports = {"ChapterHeading":"ChapterHeading--2hFUo","ChapterHeading-preHeading":"ChapterHeading-preHeading--2AfdM","ChapterHeading-heading":"ChapterHeading-heading--3YOLX"};